import { createProconInstances, proconStatus, ProconUI } from './proconUI';
import { API } from '../api/api';
import Axios from 'axios';

export class Procon {
    constructor(private ui: ProconUI) {
        this.ui.onRestartClick(this.restart.bind(this));
        this.ui.onStartClick(this.start.bind(this));
        this.ui.onStopClick(this.stop.bind(this));
    }
    
    public start() {
        API.post('start', false, {}, true, '.server__cover__loader');
    }
    
    public stop() {
        API.post('stop', false, {}, true, '.server__cover__loader');
    }
    
    public restart() {
        API.post('restart', false, {}, true, '.server__cover__loader');
    }
    
    static updateStatus() {
        Axios.post(
            API.buildUrl('getServerStateFromDaemon', true, true),
            {},
            {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'X-Requested-With': 'XMLHttpRequest'
                }
            }
        ).then(value => {
            $('#proconVersion').text(value.data.proconVersion);
            proconStatus(value.data.state);
        }).catch(reason => {
        
        }).then(value => {
            setTimeout(Procon.updateStatus, 60 * 1000);
        });
    }
}

export function initProcon() {
    return createProconInstances().map((ui: ProconUI) => {
        return new Procon(ui);
    });
}